import React from 'react';
import styled from 'styled-components';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/common/ui/select';

const AnalyticsViewSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export type DashboardView =
  | 'dashboard'
  | 'overview'
  | 'pillars'
  | 'feedback'
  | 'insights'
  | 'demographics'
  | 'resources'
  | 'outcomes';

export const dashboardViewOptions = [
  { value: 'dashboard' as DashboardView, label: 'Dashboard' },
  { value: 'resources' as DashboardView, label: 'Resources' },
];

interface AnalyticsViewSelectorProps {
  dashboardView: DashboardView;
  onDashboardViewChange: (view: DashboardView) => void;
  disabled?: boolean;
}

// NEA: Leaving this for now. This sets up the ability to move ALL analytics (org admin) into analytics
export const AnalyticsViewSelector: React.FC<AnalyticsViewSelectorProps> = ({
  dashboardView,
  onDashboardViewChange,
  disabled = false,
}) => {
  const handleValueChange = (value: string) => {
    if (disabled) return;
    const selectedOption = dashboardViewOptions.find(opt => opt.value === value);
    if (selectedOption) {
      onDashboardViewChange(selectedOption.value);
    }
  };

  return (
    <AnalyticsViewSelectorContainer>
      <Select value={dashboardView} onValueChange={handleValueChange} disabled={disabled}>
        <SelectTrigger className="w-[160px]">
          <SelectValue>
            <span>
              {dashboardViewOptions.find(opt => opt.value === dashboardView)?.label || 'Dashboard'}
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {dashboardViewOptions.map(option => (
            <SelectItem key={option.value} value={option.value}>
              <span>{option.label}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </AnalyticsViewSelectorContainer>
  );
};



